import React from "react";
import { ContentPreviewStack } from "src/components/ContentPreviewStack";
import { OffersPreviewStack } from "src/components/OffersPreviewStack";
import RecommendedBets from "src/components/RecommendedBets";
import PopularEvents from "src/components/PopularEvents";
import styles from "./styles.scss";
import { WebSportItem } from "src/constants";
import Surveys from "../Surveys";

const GamesRail = ({ currentSportObj }: { currentSportObj: WebSportItem }) => {
  const sportKey = currentSportObj.url;
  return (
    <div className="games-rail">
      <div className="games-rail__slot with-border">
        <OffersPreviewStack />
      </div>

      <div className="games-rail__slot with-border d-md-none d-xl-block">
        <ContentPreviewStack
          titleText="See More From BetQL"
          linkText={`See all ${currentSportObj.name} stories`}
          linkUrl={`/${sportKey}`}
          sportKey={sportKey}
          sidebarKey="see_more_from_betql"
        />
      </div>
      <div className="games-rail__slot" style={{ borderWidth: 0 }}>
        <RecommendedBets />
      </div>
      <div className="games-rail__slot" style={{ borderWidth: 0 }}>
        <PopularEvents />
      </div>
      <div className="games-rail__slot d-md-none d-xl-block">
        <Surveys />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default GamesRail;
